var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5688 3.08035C13.826 2.89412 14.1738 2.89411 14.431 3.08035L19.5999 6.8226L24.7563 10.5821C25.0129 10.7692 25.1204 11.0999 25.0228 11.4021L23.0609 17.4745L21.0788 23.5403C20.9802 23.8421 20.6989 24.0465 20.3813 24.0471L13.9999 24.0577L7.61852 24.0471C7.30094 24.0465 7.01961 23.8421 6.92097 23.5403L4.93887 17.4745L2.97706 11.4021C2.87943 11.0999 2.98688 10.7692 3.24349 10.5821L8.39988 6.8226L13.5688 3.08035Z",
    fill: "url(#paint0_linear_6959_65663)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9655 0.613846C13.197 -0.204615 14.8016 -0.204616 16.0331 0.613846L16.1552 0.698559L21.3241 4.441L21.332 4.44674L26.488 8.20641C27.771 9.14189 28.3086 10.7954 27.8204 12.3064L25.8584 18.3784L25.8555 18.3877L23.8734 24.4533C23.3802 25.9626 21.9736 26.9848 20.3858 26.9875L14.0043 26.9983H13.9943L7.61283 26.9875C6.02504 26.9848 4.61843 25.9626 4.12525 24.4533L2.14311 18.3877L2.14024 18.3784L0.178207 12.3064C-0.309937 10.7954 0.227631 9.14189 1.51064 8.20641L6.66663 4.44674L6.67453 4.441L11.8434 0.698559L11.9655 0.613846ZM14.4308 3.08057C14.1735 2.89433 13.8251 2.89433 13.5679 3.08057L8.39894 6.82301L3.24294 10.582C2.98633 10.7691 2.87897 11.1003 2.9766 11.4025L4.93792 17.4746L6.92005 23.5401C7.01869 23.842 7.30031 24.0464 7.61786 24.047L13.9993 24.0577L20.3808 24.047C20.6586 24.0465 20.9084 23.8899 21.0326 23.6485L21.0786 23.5401L23.0607 17.4746L25.022 11.4025C25.1196 11.1003 25.0123 10.7691 24.7557 10.582L19.5997 6.82301L14.4308 3.08057Z",
    fill: "url(#paint1_linear_6959_65663)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6959_65663",
    x1: 13.9999,
    y1: 2.76823,
    x2: 13.9999,
    y2: 26.2925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6959_65663",
    x1: 49.2858,
    y1: 14.5304,
    x2: 2.23716,
    y2: 14.5304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.432692,
    stopColor: "#006EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankDefault);
export default __webpack_public_path__ + "static/media/rank-default.272c127eec49f9b7910f75110487a95c.svg";
export { ForwardRef as ReactComponent };